import { Box, Typography } from '@mui/material'
import React from 'react'

const StatItem = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <Box sx={{ display: 'flex', gap: 0.5 }}>
    <Typography variant="text2">{label}:</Typography>
    <Typography>{value}</Typography>
  </Box>
)

export default StatItem
